import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import SectionAndTeam from './SectionAndTeam';
import Code from './Code';
import ErrorMsg from './ErrorMsg';

import { Wrapper, Loader, LoaderWrapper } from './elements';

const pages = {
  sectionAndTeam: SectionAndTeam,
  code: Code,
  error: ErrorMsg,
};

const deps = {
  isLoaded: state.account.joinCampaign.loaded,
  subPage: state.account.joinCampaign.subPage,
};

export function JoinCampaign({
  isLoaded,
  subPage,
}: typeof deps & ConnectedProps): React.ReactElement {
  if (!isLoaded || !pages[subPage]) {
    return (
      <Wrapper>
        <LoaderWrapper>
          <Loader color={'#fff'} />
        </LoaderWrapper>
      </Wrapper>
    );
  }

  const Page = pages[subPage];

  return (
    <Wrapper>
      <Page />
    </Wrapper>
  );
}

export default connect(deps, JoinCampaign);
